import { useEffect, useState } from "react";
import { useAppSelector } from "redux/hooks";
import {
  fetchCellAiConfigs,
  selectLensEditorAiFieldConfigById,
  selectLensEditorLensId,
  selectProfileBuilderAiMode,
  selectProfileBuilderFieldById,
} from "redux/slices/lensEditor";
import useAppDispatchWithSnackbar from "../../../helpers/hooks/useAppDispatchWithSnackbar";
import { useParamNumbers } from "helpers/hooks/useParamNumbers";
import { Navigate, Outlet } from "react-router-dom";
import { AiFieldPreview } from "./AiFieldPreview";
import NewCellDialog from "./NewCellDialog";

const ProfileBuilderField = () => {
  // Move to ID, so the state gets refreshed automatically
  const { fieldId } = useParamNumbers(["fieldId"]);
  const [showNewCellDialog, setShowNewCellDialog] = useState<boolean>(false);
  const aiMode = useAppSelector(selectProfileBuilderAiMode);
  const aiFieldConfig = useAppSelector((state) => selectLensEditorAiFieldConfigById(state, fieldId || 0));
  const snackpatch = useAppDispatchWithSnackbar();
  const lensId = useAppSelector(selectLensEditorLensId);
  const selectedField = useAppSelector((state) => selectProfileBuilderFieldById(state, fieldId));

  useEffect(() => {
    if (fieldId !== undefined) {
      snackpatch(
        fetchCellAiConfigs({
          lensId: lensId,
          fieldId: fieldId,
        }),
        {
          errorMessage: "Failed to fetch cell AI configs",
        }
      );
    }
  }, [fieldId]);

  if (!selectedField || fieldId === undefined) {
    return <Navigate to="../.." relative="path" />;
  }

  return (
    <div className="grid gap-4">
      {aiMode && aiFieldConfig && (
        <div className="p-4 bg-white rounded-md shadow">
          <p className="text-xl font-bold">Field AI Config</p>
          <AiFieldPreview aiFieldConfig={aiFieldConfig} />
        </div>
      )}
      {showNewCellDialog && (
        <NewCellDialog
          open={showNewCellDialog}
          close={() => setShowNewCellDialog(false)}
          field={selectedField}
          rank={selectedField.cells.length}
        />
      )}
      <Outlet />
    </div>
  );
};

export default ProfileBuilderField;
